import { useEffect, useState } from "react";
import { _BudgetCostingCenter } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { CostingCenterSelect } from "../../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { FileInput } from "../../../../theme/Component/FileInput";
import { SelectAccountantTree } from "../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";

interface Props {
    IDUBLItemInvoice: number;
    IssueDate: any;
    onChange?: (isValid: boolean, percentValue: number) => void;
}

export const UBLCostingCenter = ({ IDUBLItemInvoice, IssueDate, onChange }: Props) => {

    const budgetCostinCenter = useDataBean(_BudgetCostingCenter);
    const [lista, setLista] = useState<any>([]);
    const [row, setRow] = useState<any>({});
    const [total, setTotal] = useState<number>(0);
    const [docImport, setDocImport] = useState<any>({});

    const modalImport = useModal("Importar Centro de Costo", MODAL_md);
    const modalEditar = useModal("Centro de Costo", MODAL_md);
    const modalDelete = useModal("Centro de Costo", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDUBLCostingCenter', visible: true, mask: MASK_NUMBER },
        { title: 'Código', property: 'CostingCenterCode', visible: true },
        { title: 'Nombre', property: 'CostingCenterName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Porcentaje', property: 'PercentValue', visible: true }
    ]

    useEffect(() => {
        getUBLCostingCenterCatalog();
    }, [])

    const getUBLCostingCenterCatalog = () => {
        if (IDUBLItemInvoice) {
            budgetCostinCenter.instance.getUBLCostingCenterCatalog(IDUBLItemInvoice, IssueDate).then((resp: any) => {
                setLista(resp);
                budgetCostinCenter.instance.getUBLCostingCenterSum(IDUBLItemInvoice, IssueDate).then((resp: any) => {
                    const percentValue = typeof resp === "number" ? resp : 0;
                    setTotal(percentValue);
                    if (onChange) {
                        onChange(percentValue === 100, percentValue);
                    }
                })
            })

        } else {
            toast.warning("No se ha seleccionado un formato de factura valido.");
        }
    }

    const agregar = () => {
        modalEditar.open();
        setRow({
            // AccountantIDStr: row.AccountantID,
            idUBLItem: IDUBLItemInvoice,
            issueDate: IssueDate,
            IDCostingCenter: 0,
            percentValue: 100 - total
        })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: () => { agregar() } },
        { nombre: 'Importar Valores desde Excel', visible: true, icono: 'ri-file-upload-line', evento: () => { modalImport.open() } },
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar', icono: ' ri-eraser-fill', visible: true, evento: () => { modalDelete.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const addConstingCenter = () => {
        console.log(row);
        budgetCostinCenter.instance.addUBLCostingCenter4(IDUBLItemInvoice, IssueDate, row.IDCostingCenter, row.percentValue, row.AccountantIDStr).then(
            (resp: any) => {
                console.log(resp);

                getUBLCostingCenterCatalog();
                modalEditar.close();
            }
        )

    }
    const deleteUBLCostingCenter = () => {
        budgetCostinCenter.instance.deleteUBLCostingCenter(row.IDUBLCostingCenter, row.IssueDate).then((resp: any) => {
            getUBLCostingCenterCatalog();
            modalDelete.close();
        })
    }

    const onInport = () => {
        console.log(docImport);

        budgetCostinCenter.instance.importCostingCenterModel(IDUBLItemInvoice, IssueDate, docImport.fileName, docImport.directory, null).then(
            (resp) => {
                modalImport.close();
                getUBLCostingCenterCatalog();
                resp.map((item: any) => {
                    toast.info(item, { autoClose: false })
                })
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <div className="row">
            <div className="col-md-12">

                <BasicTable head={head} body={lista} rowSet={setRow} iconButtons={iconButtonsItem} listButtons={listaBotones()} ></BasicTable>
                <p>Porcentaje : {total}%</p>
                <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={addConstingCenter} onSubmitLabel="Agregar" >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Centro de Costo</label>
                            <CostingCenterSelect idSelector={row.IDCostingCenter} label=" " onChange={(e: any) => { console.log(e); setRow({ ...row, "IDCostingCenter": e?.IDCostingCenter }) }} returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <SelectAccountantTree label="Cuenta Contable" jsonCode={row.AccountantIDStr} onChange={(e) => { setRow({ ...row, "AccountantIDStr": e.JsonCode }) }} />


                        </div>
                        <div className="col-md-6">
                            <label>Porcentaje</label>
                            <input type="number" className="form-control" value={row.percentValue} onChange={(e) => { setRow({ ...row, "percentValue": parseFloat(e.target.value) }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={onInport} onSubmitLabel="Importar" >
                    <div className="row">
                        <div className="col-md-12">
                            <FileInput onCreate={({ Media, MediaContext }) => { setDocImport({ fileName: Media, directory: MediaContext }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteUBLCostingCenter}>
                    Eliminar Item
                </ModalConfirm>
            </div>

        </div>
    )
}
